import React from 'react';
import PropTypes from 'prop-types';
import QuizResults from './QuizResults.jsx';
import Steps from './Steps';
import { Button, Link, Container } from '@paypalcorp/pp-react';
import Card from 'kepler/lib/components/Card';
import { remove, times, extend, get } from 'lodash';
import { quizCardSteps } from '../lib/quizSteps';
import {
  generateFinalProducts,
  shouldSkipToResults
} from '../lib/quizResults.js';
import getContent from '../lib/dictionaryFetcher';
import { QUIZ_CONSTANTS } from '../lib/constants';
import { stepPageFPTI, optionsToFPTIMapping } from '../lib/quizStaticMapping';
export default class Quiz extends React.Component {
  constructor() {
    super();
    this.state = {
      currentStep: 1, // Default is Step 1
      steps: this.generateStepsObj(),
      skipToResultsPage: false,
      noProductsSelectedError: false
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  generateStepsObj() {
    let steps = {};
    times(QUIZ_CONSTANTS.numberOfQuestions, stepNumber => {
      steps[stepNumber + 1] = [];
    });
    return steps;
  }
  get previousButton() {
    return (
      <Link
        className="quiz-back"
        as="button"
        style={{ border: 0, background: 'inherit' }}
        onClick={this.prevStep}
      >
        <span
          className="ppvx_icon ppvx_icon--size_sm ppvx_icon-chevron-left quiz-back-icon"
          role="presentation"
        />
        {getContent('quiz', 'back', '')}
      </Link>
    );
  }
  prevStep = () => {
    const { currentStep } = this.state,
      { location } = this.props;
    this.fptiBackbuttonCl(currentStep);
    if (currentStep === 1) {
      if (get(location, 'search', '').includes('appcenter=true'))
        window.location.href = '/merchantapps/appcenter';
      else window.location.href = '/mep/dashboard';
    } else {
      this.setState(prevState => {
        let step = prevState.currentStep <= 1 ? 1 : prevState.currentStep - 1;
        this.nextButtonFPTIIm(step);
        return {
          currentStep: step,
          steps: {
            ...prevState.steps,
            [prevState.currentStep]: []
          },
          noProductsSelectedError: false
        };
      });
    }
  };
  fptiBackbuttonCl = currentStep => {
    let { fptiHelper, location } = this.props,
      stepNumber = `step${currentStep}`,
      stepPageFPTIVal = get(stepPageFPTI, `${stepNumber}`, '');

    fptiHelper.fptiClick({
      page: `main:businessweb:mep:dashboard:main:quiz:${stepPageFPTIVal}`,
      entry_point: get(location, 'search', '').includes('appcenter=true'),
      link: 'back'
    });
  };
  get nextButton() {
    let nextButtonContent = getContent('quiz', 'continue', '');
    return (
      <Button
        className="quiz-next-button"
        key="submit"
        type="primary"
        onClick={this.nextStep}
      >
        <span className="quiz-next-button-text">{nextButtonContent}</span>
      </Button>
    );
  }
  nextStep = () => {
    let { currentStep, steps } = this.state,
      skipToResultsPage = shouldSkipToResults(steps[currentStep], currentStep),
      nextState = {};
    if (steps[currentStep].length === 0) {
      extend(nextState, { noProductsSelectedError: true });
    } else {
      this.nextButtonFPTIClick(currentStep);
      let nextStep = skipToResultsPage ? currentStep : (currentStep += 1);
      if (!skipToResultsPage && nextStep <= QUIZ_CONSTANTS.numberOfQuestions) {
        this.nextButtonFPTIIm(nextStep);
      }
      extend(nextState, {
        currentStep: nextStep,
        skipToResultsPage,
        noProductsSelectedError: false
      });
    }
    this.setState(nextState);
    window.scrollTo(0, 0);
  };
  nextButtonFPTIIm = nextStep => {
    let stepNumber = `step${nextStep}`,
      { fptiHelper, location } = this.props,
      stepPageFPTIVal = get(stepPageFPTI, `${stepNumber}`, '');

    fptiHelper.fptiImpression({
      page: `main:businessweb:mep:dashboard:main:quiz:${stepPageFPTIVal}`,
      entry_point: get(location, 'search', '').includes('appcenter=true')
    });
  };
  nextButtonFPTIClick = currentStep => {
    let stepNumber = `step${currentStep}`,
      { fptiHelper, location } = this.props,
      optionsSelectedForFPTI = this.optionsSelectedForFPTI(currentStep).join(),
      stepPageFPTIVal = get(stepPageFPTI, `${stepNumber}`, '');

    fptiHelper.fptiClick({
      page: `main:businessweb:mep:dashboard:main:quiz:${stepPageFPTIVal}`,
      entry_point: get(location, 'search', '').includes('appcenter=true'),
      link: stepPageFPTIVal,
      optsel: optionsSelectedForFPTI
    });
  };
  optionsSelectedForFPTI = currentStep => {
    let { steps } = this.state,
      optionsSelected = steps[currentStep],
      finalOptions = [];
    optionsSelected.forEach(option => {
      let fptiOption = optionsToFPTIMapping[`step${currentStep}`][option];
      finalOptions.push(fptiOption);
    });
    return finalOptions;
  };
  handleChange = value => {
    let { steps, currentStep } = this.state;
    if (currentStep === 4) {
      this.setState(prevState => ({
        steps: {
          ...prevState.steps,
          [currentStep]: [value]
        },
        noProductsSelectedError: false
      }));
    } else {
      steps[currentStep].includes(value)
        ? remove(steps[currentStep], product => product === value)
        : steps[currentStep].push(value);
      this.setState({
        steps,
        noProductsSelectedError: false
      });
    }
  };
  retrieveProductsFromOptions = (steps, productcompletion) => {
    const { currentStep } = this.state;
    const { tools, app } = this.props;
    return generateFinalProducts({
      steps,
      currentStep,
      tools,
      productcompletion,
      app
    });
  };
  getView = () => {
    const {
      steps,
      currentStep,
      skipToResultsPage,
      noProductsSelectedError
    } = this.state;
    const { app, location, productcompletion, fptiHelper } = this.props;
    const stepNumber = `step${currentStep}`;
    if (currentStep <= QUIZ_CONSTANTS.numberOfQuestions && !skipToResultsPage) {
      let stepContent = quizCardSteps(stepNumber, app);
      return (
        <div>
          {this.previousButton}
          <Card
            className="quiz-container"
            style={{
              padding: stepContent.square ? '48px 210px' : '48px 180px'
            }}
          >
            <Steps
              products={steps[currentStep]}
              handleChange={this.handleChange}
              steps={stepContent}
              noProductsSelectedError={noProductsSelectedError}
              stepNumber={stepNumber}
              location={location}
              fptiHelper={fptiHelper}
            />
            <div className="quiz-next-container">{this.nextButton}</div>
          </Card>
        </div>
      );
    }
    let quizResultCards = this.retrieveProductsFromOptions(
      steps,
      productcompletion
    );
    return (
      <QuizResults
        userProducts={quizResultCards.user}
        developerProducts={quizResultCards.developer}
        extras={quizResultCards.extras}
        app={app}
        location={location}
        fptiHelper={fptiHelper}
      />
    );
  };
  render() {
    return (
      <Container>
        <div className="quiz">{this.getView()}</div>
      </Container>
    );
  }
}
Quiz.propTypes = {
  app: PropTypes.object,
  location: PropTypes.object,
  tools: PropTypes.object,
  productcompletion: PropTypes.object,
  fptiHelper: PropTypes.object
};
